import {
    DataSnapshot,
    get,
    onChildAdded,
    onChildChanged,
    onChildRemoved,
    ref,
} from 'firebase/database'
import { LocationParams } from './school-api'
import { db, functions } from './configs'
import { httpsCallable } from 'firebase/functions'
import {
    CancelReplacementProps,
    CancelReplacementResponse,
} from './types-opportunities'

// TODO Get type

export const OPPORTUNITIES_API = {
    fetchSchoolRequests: async (
        args: LocationParams & { schoolId: string }
    ) => {
        return await get(
            ref(
                db,
                `countries/${args.country}/${args.locationState}/autoReplacements/schools/${args.schoolId}/requests`
            )
        )
    },

    listenReplacements: (
        args: LocationParams & {
            schoolUid: string
            callback: {
                added: (snap: DataSnapshot) => void
                changed: (snap: DataSnapshot) => void
                removed: (snap: DataSnapshot) => void
            }
        }
    ) => {
        const thisRef = ref(
            db,
            `countries/${args.country}/${args.locationState}/autoReplacements/schools/${args.schoolUid}/requests`
        )
        return [
            onChildAdded(thisRef, args.callback.added),
            onChildChanged(thisRef, args.callback.changed),
            onChildRemoved(thisRef, args.callback.removed),
        ]
    },

    // Mutations
    cancelPendingOpportunity: (data: CancelReplacementProps) =>
        httpsCallable<CancelReplacementProps, CancelReplacementResponse>(
            functions,
            'cancelReplacementRequest'
        )(data),
} as const
